<template>
  <div class="m-card card-gradient">
    <div class="header">
      <h4 class="tb_700">Workforce Status</h4>
    </div>
    <div class="content">
      <vs-table max-items="5" pagination :data="fakeDataCom" >
      <template slot="header">
        
      </template>
      <template slot="thead" >
        <vs-th>
        </vs-th>
        <vs-th >
          Employee ID
        </vs-th>
        <vs-th>
          Employee Name
        </vs-th>
        <vs-th>
          Tag Mac Address
        </vs-th>
        <vs-th>
          Tag Type
        </vs-th>
        <vs-th>
          Today Status
        </vs-th>
        <vs-th>
          Frist Check-in
        </vs-th>
        <vs-th>
          Last Check-out
        </vs-th>
        <vs-th>
          Daily Cumulative Working Time
        </vs-th>
        <vs-th>
          Tag Battery
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" style="text-align: center;">
          <vs-td>
            <vs-button color="success" type="flat" icon="add">view</vs-button>
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{data[indextr].id}}
          </vs-td>

          <vs-td :data="data[indextr].name">
            {{data[indextr].name}}
          </vs-td>

          <vs-td :data="data[indextr].mac">
            {{data[indextr].mac}}
          </vs-td>

          <vs-td :data="data[indextr].model">
            {{data[indextr].model}}
          </vs-td>
          <vs-td :data="data[indextr].status">
            {{data[indextr].status== 1? 'Present':'Absent'}}
          </vs-td>
          <vs-td :data="data[indextr].frist">
            {{data[indextr].frist}}
          </vs-td>
          <vs-td :data="data[indextr].last">
            {{data[indextr].last}}
          </vs-td>
          <vs-td :data="data[indextr].timecount">
            {{data[indextr].timecount}}
          </vs-td>
          <vs-td :data="data[indextr].battery">
            {{data[indextr].battery}} %
          </vs-td>

          
        </vs-tr>
      </template>
    </vs-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users:[],
      fakeData: [],
      arrayName:[
        'ผกาพรรณ ศิลามหาฤกษ์',
        'พรทิพา ศิลามหาฤกษ์',
        'จินตพร ครองจินดา',
        'บัณฑิต จุฑาเทพ ณ อยุธยา',
        'อานันท์ กองการ',
        'ภาณุภัทร พิทักษ์ไทย',
        'กฤตยา พรรณาราย',
        'กฤษฎา พิทักษ์ไทย',
        'พรนภา จิตประสงค์',
        'กนกพรรณ เกิดความสุข',
        'ดนุเดช วรเลิศรัตน์',
        'ชนกนันท์ กล้านอนหงาย',
        'จุฑามณี นิมิตนาม',
        'ดนุเดช พิทักษ์ไทย',
        'ไอริณ ศิวาวงศ์ ',
        'กนกอร ประภาพร ',
        'กชวรรณ พรรณาราย',
        'ปฏิพล พงศ์พิทักษ์',
        'จุไรวรรณ มหานิยม',
        'ปิยนุช จิรามณี',
        'ภูวเดช วิทยเขตปภา'
      ],
    }
  },
  computed: {
    fakeDataCom: function () {
      return this.fakeData;
    },
  },
  mounted() {
    for (let i = 1; i <= 30; i++) {
      let no = (i / 1000).toFixed(3);
      let j = i%21
      let data = {
        id:'SWD'+no.slice(2),
        name: this.arrayName[j],
        mac: "AC983247" + no.slice(2),
        model: "E8",
        status:Math.round(Math.random()) ,
        frist:this.$moment().format('YYYY-MM-DD hh:mm:ss'),
        last:this.$moment().format('YYYY-MM-DD hh:mm:ss'),
        timecount:(Math.random() * (8 - 0) + 0).toFixed(2)+' hr',
        battery: Math.round(Math.random() * (100 - 40) + 40),
      };
      this.fakeData.push(data);
      console.log(data.dis);
    }
  },
};
</script>

<style lang="scss" scoped>
.tb_700 {
  font-weight: 700;
  color: var(--text-color-2);
}
.header{
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.card-gradient {
  background: linear-gradient(
    180deg,
    #8e48c5 0%,
    var(--background-color-sidebar) 45px,
    var(--background-color-sidebar) 100%
  );
}
.content {
  width: 100%;
text-align: center;
}
</style>